<script>
export default {
  props: {
    permission: {
      required: true
    },
    tooltipText: {
      required: false,
      type: String,
      default: ""
    },
    disabledCheckbox: {
      default: false
    },
    change: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  computed: {
    permissions: {
      get() {
        return this.$store.state.users.editedItem.permissions;
      },
      set(val) {
        this.$store.commit("users/updatePermissions", val);
      }
    }
  }
};
</script>

<template>
  <div class="d-flex justify-center align-center">
    <v-tooltip bottom :disabled="tooltipText.length === 0">
      <template v-slot:activator="{ on }">
        <span v-on="on">
          <v-checkbox
            v-if="permission !== null"
            v-model="permissions"
            color="primary"
            :value="permission"
            :disabled="disabledCheckbox"
            @change="change(permission)"
          ></v-checkbox>
          <span v-else>-</span>
        </span>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
  </div>
</template>
